module.exports = __webpack_public_path__ + "static/antes de usar cup-e3c88a0864186b5198b1e4c51630d503.png";